import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/partials/base/base.component';
import { AuthGuard } from './core/auth.guard';

const routes: Routes = [
    {
        path: '',
        component: BaseComponent,
        children: [
            {
                path: '',
                redirectTo: 'onboarding', // TODO: Redirect to Landing Page Switcher
                pathMatch: 'full',
            },
            {
                path: 'onboarding',
                loadChildren: () =>
                    import('./views/pages/onboarding/onboarding.module').then(
                        (m) => m.OnboardingModule,
                    ),
                canActivate: [AuthGuard]
            },
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('./views/pages/dashboard/dashboard.module').then(
                        (m) => m.DashboardModule
                    ),
                canActivate: [AuthGuard]

            }
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
